import { render, staticRenderFns } from "./the-impersonate-bar.vue?vue&type=template&id=458395d6&"
import script from "./the-impersonate-bar.vue?vue&type=script&lang=js&"
export * from "./the-impersonate-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VIcon,VSystemBar})
